var _path, _g, _g2, _g3, _g4, _g5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgToothpicks = function SvgToothpicks(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICONS",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.36,392.82c-2.89,0-28.93-.97-28.93-31.34,0-1.69-1.45-3.13-3.13-3.13s-3.13,1.45-3.13,3.13c0,30.38-26.04,31.34-28.93,31.34h-.24c-1.69,.24-2.89,1.44-2.89,3.13s1.45,3.13,3.13,3.13c3.13,0,28.93,.96,28.93,31.34,0,1.69,1.44,3.13,3.13,3.13,1.45,.24,2.89-1.2,2.89-2.89,0-30.38,26.04-31.34,28.93-31.34h.24c1.69,0,3.14-1.45,3.14-3.38,0-1.69-1.45-3.13-3.14-3.13Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.87,285.89c35.94,189.31,51.27,241.7,56.76,256.11L321.22,48.18c-1.13,2.17-7.73,25.06,32.64,237.7Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.24,547.42l-1.02-5.57c0,1.59-.07,2.76-.14,3.61,.82,1.74,1.16,1.96,1.16,1.96Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,47.97s-.04,.03-.09,.13c.03,.03,.08,.06,.14,.12l-.05-.25Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.27,48.1s-.07-.04-.07-.04l.02,.13,89.41,493.81,1.03,5.69s.25-.31,.41-2.23c.07-.85,.13-2.02,.14-3.61,.09-15.15-3.97-69.04-37.19-258.71-37.32-213.04-51.76-233.14-53.61-234.92-.06-.06-.11-.09-.14-.12Z",
    fill: "#fdb73e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.97,312.47c124.66,159.61,164.05,201.88,176.05,213.06L197.81,107.64c.02,2.38,5.14,25.54,145.16,204.82Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.02,529.54l-3.64-4.71c.77,1.45,1.28,2.54,1.63,3.33,1.59,1.29,2.01,1.37,2.01,1.37Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,107.4s-.02,.04-.02,.15c.04,.01,.1,.03,.19,.06l-.16-.21Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.81,107.55c-.06-.01-.08-.02-.08-.02l.08,.11,321.2,417.88,3.7,4.82s.08-.37-.71-2.18c-.35-.8-.86-1.88-1.63-3.33-7.28-13.83-37.14-61.44-159.5-222.33C223.45,121.77,200.55,108.57,198,107.61c-.08-.03-.14-.05-.19-.06Z",
    fill: "#fdb73e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.59,345.82c181.62,113.08,235.71,141.14,251.49,148.1L88.43,196.35c.99,2.22,15.16,22.45,219.16,149.47Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.4,496.21l-5.32-3.35c1.31,1.14,2.23,2,2.88,2.65,2.01,.74,2.44,.7,2.44,.7Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.36,196.12s0,.04,.04,.15c.05,0,.11,0,.2,0l-.24-.15Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.39,196.26c-.06,0-.09,.01-.09,.01l.12,.08,470.65,297.57,5.42,3.43s-.08-.37-1.54-1.83c-.65-.65-1.57-1.51-2.88-2.65-12.43-10.83-59.73-46.72-239.71-161.68C118.21,202.05,91.37,196.42,88.59,196.26c-.09,0-.15,0-.2,0Z",
    fill: "#fdb73e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.02,279.77c-93.63,174.37-115.06,225.17-119.9,239.75L427.95,66.76c-2.36,1.27-22.77,17.16-127.93,213.01Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,525.27l2.78-5.12c-1.05,1.32-1.85,2.26-2.47,2.93-.45,1.83-.31,2.18-.31,2.18Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.21,66.65s-.05,0-.16,.06c.01,.04,.03,.09,.04,.17l.12-.23Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,66.71c-.02-.05-.03-.07-.03-.07l-.06,.12-247.83,452.76-2.86,5.22s.41-.14,1.8-1.66c.61-.67,1.42-1.61,2.47-2.93,9.96-12.55,41.74-59.25,137.85-232.62,107.96-194.74,109.07-218.29,108.69-220.65-.01-.08-.03-.13-.04-.17Z",
    fill: "#fdb73e"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.76,312.31c-39.78,188.75-45.71,242.51-46.14,257.66L439.49,78.85c-1.91,1.73-17.04,21.45-61.73,233.47Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.97,575.82l1.2-5.55c-.63,1.5-1.14,2.58-1.54,3.37,.1,1.87,.33,2.18,.33,2.18Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7,78.69s-.05,.02-.14,.09c.02,.03,.05,.08,.08,.15l.05-.25Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,78.78s-.05-.06-.05-.06l-.03,.13-107.87,491.12-1.24,5.66s.36-.22,1.26-1.99c.4-.78,.91-1.87,1.54-3.37,5.99-14.27,23.13-66.25,65.61-254.57,47.72-211.53,41.92-234.58,40.87-236.78-.03-.07-.06-.12-.08-.15Z",
    fill: "#fdb73e"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToothpicks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toothpicks.ff2e2219.svg";
export { ForwardRef as ReactComponent };